// extracted by mini-css-extract-plugin
module.exports = {"card":"MyTeam_card__d1WK0","pfp":"MyTeam_pfp__3IesM","teamMemberPhoto":"MyTeam_teamMemberPhoto__JDVVL"};